module.exports = __webpack_public_path__ + "img/cloudview_flight-status.184aee16.jpg";